import { Component } from '@angular/core';
import { slideInLeftOnEnterAnimation, slideInRightOnEnterAnimation } from 'angular-animations';

@Component({
  selector: 'number-in-initiatives',
  standalone: true,
  imports: [],
  templateUrl: './number-in-initiatives.component.html',
  styleUrl: './number-in-initiatives.component.scss',
  animations: [
      slideInLeftOnEnterAnimation({ anchor: 'slideInLeft' }),
      slideInRightOnEnterAnimation({ anchor: 'slideInRight' })
    ]
})
export class NumberInInitiativesComponent {

}
